/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minor_Neat_Osprey_TapInputs */

const fr_minor_neat_osprey_tap = /** @type {(inputs: Minor_Neat_Osprey_TapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brouillon`)
};

/**

* @param {Minor_Neat_Osprey_TapInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const minor_neat_osprey_tap = /** @type {((inputs?: Minor_Neat_Osprey_TapInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minor_Neat_Osprey_TapInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_minor_neat_osprey_tap(inputs)
});